export enum PopupMessageTypes {
    Success = 'success',
    Info = 'info',
    Warn = 'warn',
    Error = 'error',
    Multiple = 'multiple'
}



// WEBPACK FOOTER //
// ./src/app/shared/dictionaries/PopupMessageTypes.ts